const Theme = {
  body_background_color: '#00305c',

  header_border_color: '#eee',
  header_no_margin: true,

  logo_image_url: 'routedesnavigateurs.png',
  logo_height: 180,

  token_url: 'routedesnavigateurs.png',
  token_width: 70,
  token_hidden_tokenIds: [0],

  number_font: `'Intro Script R', serif`,
  number_color: 'white',
  number_top: 21,
  number_weight: 500,

  button_color: '#00305c',
  button_radius: 15,
  button_font: `'Open Sans', sans-serif`,
  button_text_weight: 600,
  button_text_size: 14,

  button_half_border_color: '#00305c',
  button_half_text_weight: 600,
  button_half_text_size: 14,

  title_font: `'Intro Head R', sans-serif`,
  title_size: 32,
  title_lineheight: 30,

  subtitle_size: 24,

  separator_color: '#4a65ac',

  footer_border_color: '#eee',
}

export default Theme
